import React, { createContext, useReducer } from 'react';

import { ChowNowFacetType, ChowNowRestaurantType, SearchFiltersFromUrlType } from 'types/restaurant';
import { reducer, defaultState } from '../reducer/index';

interface Aggregation {
  key: string;
  doc_count: number;
}

interface ReducerState {
  isMapView: boolean;
  searchWithMap: boolean;
  hoveredRestaurantId?: string;
  restaurantSearchAPI: {
    restaurants: Array<ChowNowRestaurantType>;
    aggregations: {
      cuisines: Array<Aggregation>;
    };
    byId: Record<number, ChowNowRestaurantType>;
    loadedIds: Array<number>;
    areRestaurantsLoading: boolean;
  };
  // TODO(Isolde): Clean up this state when facet api is stable
  newRestaurantsAPI: {
    restaurants: Array<ChowNowRestaurantType>;
  };
  restaurantListState: string;
  autoCompleteAPI: {
    isLoading: boolean;
    results?: Array<ChowNowRestaurantType>;
  };
  geocodedSearchedAddress?: {
    city: string;
    country: string;
    formatted_address: string;
    lat: number;
    lng: number;
    street_address_1: string;
  };
  selectedRestaurantId?: string;
  searchFiltersFromURL: SearchFiltersFromUrlType;
  meta: {
    next?: string;
    count?: number;
  };
  filterPanelActive: boolean;
  autocompletePanelActive: boolean;
  facetsAPI: {
    facets: Array<ChowNowFacetType>;
  };
  moreFacetRestaurantsAPI: {
    action: string,
    name: string,
    restaurants: Array<ChowNowRestaurantType>;
    tag: string,
  };
}

interface SearchContextProps {
  state: ReducerState;
  dispatchToReducer: React.Dispatch<unknown>;
}

export const SearchContext = createContext<SearchContextProps | null>(null);

interface SearchProviderProps {
  children: React.ReactNode;
}

export default function SearchProvider({ children }: SearchProviderProps) {
  const [state, dispatchToReducer] = useReducer(reducer, defaultState);

  return (
    <SearchContext.Provider value={{ state, dispatchToReducer }}>{children}</SearchContext.Provider>
  );
}
